'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _reduxWindow = require('redux-window');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var wrapperStyles = function wrapperStyles(_ref) {
  var mobile = _ref.mobile,
    theme = _ref.theme,
    prev = _ref.prev,
    next = _ref.next;
  return {
    display: 'flex',
    flexDirection: mobile ? 'column-reverse' : 'row',
    justifyContent: !prev && next ? 'flex-end' : 'space-between',
    marginBottom: theme.space_sm
  };
};
var Wrapper = (0, _glamorous2.default)('div')(wrapperStyles);
var FormNavigation = function (_Component) {
  _inherits(FormNavigation, _Component);
  function FormNavigation() {
    _classCallCheck(this, FormNavigation);
    return _possibleConstructorReturn(this, (FormNavigation.__proto__ || Object.getPrototypeOf(FormNavigation)).apply(this, arguments));
  }
  _createClass(FormNavigation, [{
    key: 'exists',
    value: function exists(position) {
      return typeof this.props[position] !== 'undefined';
    }
  }, {
    key: 'render',
    value: function render() {
      var mobile = this.props.width <= 991;
      return _react2.default.createElement(Wrapper, {
        mobile: mobile,
        prev: this.exists('prev'),
        next: this.exists('next')
      }, this.exists('prev') && this.props.prev(mobile), this.exists('next') && this.props.next(mobile));
    }
  }]);
  return FormNavigation;
}(_react.Component);
FormNavigation.propTypes = {
  width: _propTypes.number.isRequired,
  prev: _propTypes.func,
  next: _propTypes.func
};
FormNavigation.defaultProps = {
  prev: undefined,
  next: undefined
};
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    width: (0, _reduxWindow.getWidth)(state)
  };
})(FormNavigation);